module.exports = __webpack_public_path__ + "static/media/luz-guerra-1.d076fdfa.jpg";